import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { notInOptions, Option } from '../utils/options';

const isEmptyValue = (value: any) =>
  value === undefined || value === null || value === '';

export const useAutoClearFormFieldValueIfNotInOptions = ({
  name,
  options,
  isEnabled = true,
  fallbackValue = null,
}: {
  name: string;
  options: Option[];
  isEnabled?: boolean;
  fallbackValue?: any;
}) => {
  const { setValue } = useFormContext();
  const value = useWatch({ name, disabled: !isEnabled });

  useEffect(() => {
    if (isEnabled && !isEmptyValue(value) && notInOptions(value, options)) {
      setValue(name, fallbackValue, { shouldDirty: true });
    }
  }, [name, value, options, setValue, isEnabled, fallbackValue]);
};
